import { createGlobalStyle } from "styled-components";

import { CryptoFont } from "../fonts";

const CryptoFontCSS = createGlobalStyle`
    ${CryptoFont};
`;

export default CryptoFontCSS;
